import { IonGrid } from '@ionic/react';
import styled from 'styled-components';

export const IonGridLogin = styled(IonGrid)`
  height: 100%;
  align-items: center;
  justify-content: center;
`;
